import { IPromoInfo, EPromoType } from '../../../types/newbuilding/promoInfo';

export const getAuthorLabel = (promo: IPromoInfo): string | null => {
  const cianMortgage = promo.promoType === EPromoType.CianMortgage;

  if (cianMortgage) {
    return null;
  }

  return promo.isFromBuilder ? 'Застройщик' : 'Представитель застройщика';
};
